import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { featuredProperties } from '@/mocks/properties';
import PropertyCard from '@/components/base/PropertyCard';

const FeaturedSection = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: 'left' | 'right') => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir === 'left' ? -320 : 320, behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-stone-900">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-amber-400 text-xs font-semibold uppercase tracking-widest mb-2">Handpicked For You</p>
            <h2 className="text-4xl md:text-5xl font-black text-white">Featured Properties</h2>
          </div>
          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white hover:bg-white/10 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white hover:bg-white/10 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {featuredProperties.map(property => (
            <div key={property.id} className="min-w-[300px] max-w-[300px]">
              <PropertyCard property={property} />
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/listings"
            className="inline-flex items-center gap-2 px-8 py-3 border border-white/20 text-white hover:bg-white/10 rounded-full text-sm font-semibold transition-colors cursor-pointer"
          >
            View All Properties
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;
